<div class="flex w-full justify-content-center h-full align-items-center flex-column fixed">
  <i class="text-gray-400 fa fa-server" style="font-size: 10rem"></i>
  <span class="text-6xl font-bold">Verbindung zum Server fehlgeschlagen</span>
  <span class="text-4x1">Bitte kontaktieren Sie Ihren Systemadministrator</span>
  <br />
  <div class="p-float-label mb-3" style="max-width: 80vw; width: 60rem">
    <input type="text" pInputText [(ngModel)]="baseUrl" class="w-full" (input)="onInput()" />
  </div>
  <p-button icon="pi pi-save" label="Setzen" [disabled]="!urlIsValid" (click)="setUrl()"></p-button>
</div>
